export const PRE_ORDER_FLOW_TABLE = "preOrderFlows"
// Indexed for: list-by-company, by-pre-order (recap flows table), by-status,
// by-deletion (tombstones), by-syncId (delta resume), and three compound
// indexes that power the recap product-view bootstrap. `uniqueKeys()` reads
// the indexed tuples directly without materializing flow rows:
//   - `[preOrderId+productId]` — distinct (preOrderId, productId) for the
//     product enumeration (`useProductBreakdownForPreOrders`).
//   - `[preOrderId+productId+updatedAt]` — per-(PO, product) updatedAt for
//     min/max aggregation used by the `latest-updated` / `oldest-updated`
//     sort comparators.
//   - `[preOrderId+productId+createdAt]` — same shape for `latest-created`
//     / `oldest-created` sort.
// All three are scoped by `preOrderId` (already tenant-isolated via the
// upstream header query), so enumerating products + their flow-time
// aggregates costs an indexed range scan per PO instead of a 4 k-row JSON
// parse.
export const PRE_ORDER_FLOW_TABLE_SCHEMA =
  "id, companyId, preOrderId, productId, status, deletedAt, syncId, [companyId+preOrderId], [preOrderId+productId], [preOrderId+productId+updatedAt], [preOrderId+productId+createdAt]"
